import React, { useState, useEffect } from 'react';
import { useDispatch } from "react-redux";
import DataGrid, {
    Column,
    FilterRow,
    Position,
    ColumnChooser,
    Paging,
    Pager,
    Form,
    ToolbarItem,
    Editing, HeaderFilter,
    Selection, Scrolling
    , Export, Summary, TotalItem, GroupPanel, Grouping, SearchPanel, GroupItem, SortByGroupSummaryInfo
} from 'devextreme-react/data-grid';
import 'devextreme/data/odata/store';
import CustomStore from 'devextreme/data/custom_store';
import './CariDonemPersonelDetay.scss'
import Request from "../../components/api/Request";

const CariDonemPersonelDetay = (props) => {

    const [store, setStore] = useState(null);


    useEffect(() => {
        setStore(getStore());
    }, [])
    const getStore = () => {

        return new CustomStore({
            key: 'id',
            useDefaultSearch: false,
            load: function (loadOptions) {

                const request = new Request("/cariDonemTesvikRapor/getCariDonemPersonelList/" + props.data.domainId, "GET");

                return request.run()
                    .then(response => {
                        if (response.data) {
                            let id = 1;
                            response.data.data.map(d => {
                                d.id = id;
                                id++;
                            });
                            return {
                                data: response.data.data,
                                totalCount: response.data.total,
                                summary: 0,
                                groupCount: 0
                            };
                        } else {
                            return []

                        }
                    });
            }
        });
    }
    function siraRender(data) {
        return (data.rowIndex +1);// <b>{(data.rowIndex +1)}</b> ;
    }
    return (
        <div>
            <DataGrid
                width="100%"
                className= {  "cariDonemPersonelDetayGrid"}
                //height="100%"
                dataSource={store}
                key="id"
                keyExpr="id"
                showBorders={true}
                focusedRowEnabled={true}
                allowColumnResizing={true}
                columnResizingMode={"widget"}
                columnAutoWidth={false}
                selection={{ mode: 'single', deferred: true }}
            >
                <Export enabled={true} />
                <Paging enabled={false} />
                <FilterRow visible={true} />
                <ColumnChooser enabled={true} title={"Kolon Seç"} emptyPanelText={"Buraya Sürükleyiniz..."} />
                <Scrolling columnRenderingMode="virtual" showScrollbar="always" />

                <Column width={30} caption={'Sıra'} dataType="number" visible={true} cellRender={siraRender} />
                <Column dataField={'id'} width={90} caption={'Id'} dataType="number" visible={false} />

                <Column dataField={'tcKimlikNumarasi'} width={90} caption={'Tc No'} dataType="string" mappingType="String" visible={true} />
                <Column dataField={'personelAd'} minWidth={90} width={90} caption={'Adı'} dataType="string" mappingType="String" visible={true} />
                <Column dataField={'personelSoyad'} minWidth={90} width={90} caption={'Soyadı'} dataType="string" mappingType="String" visible={true} />
                <Column dataField={'personelIlkSoyadi'} minWidth={90} width={90} caption={'İlk Soyadı'} dataType="string" mappingType="String" visible={false} />
                <Column dataField={'belgeTuru'} width={40} caption={'Belge Çeşidi'} dataType="String" visible={true} />
                <Column dataField={'kanunNumarasi'} width={60} caption={'Kanun'} dataType="number" visible={true} />
                <Column dataField={'ucret'} width={60} caption={'Ücret'} dataType="number" visible={true} />
                <Column dataField={'ikramiye'} width={60} caption={'İkramiye'} dataType="number" visible={true} />
                <Column dataField={'gun'} width={60} caption={'gun'} dataType="number" visible={true} />
                <Column dataField={'egn'} width={60} caption={'egn'} dataType="number" visible={true} />
                <Column dataField={'cgun'} width={60} caption={'cgun'} dataType="number" visible={true} />
                <Column dataField={'ggun'} width={60} caption={'ggun'} dataType="number" visible={true} />
                <Column dataField={'icn'} width={60} caption={'icn'} dataType="number" visible={true} />
                <Column dataField={'eksikGun'} width={60} caption={'eksikGun'} dataType="number" visible={true} />
                <Column dataField={'meslekAdi'} width={40} caption={'Meslek Adı'} dataType="String" visible={true} />
                <Column dataField={'meslekKodu'} width={40} caption={'Meslek Kodu'} dataType="String" visible={true} />

            </DataGrid>
        </div>
    );
}

export default CariDonemPersonelDetay;
